<script setup>
import ToggleTaskOnHoldAction from '@frontJs/components/actions/projectManagement/tasks/ToggleTaskOnHoldAction.vue';
import PauseIcon from '@iconify-vue/ph/pause';
import PlayIcon from '@iconify-vue/ph/play';
import ActionButton from '@js/components/buttons/ActionButton.vue';
import BaseCell from '@js/components/tables/cells/BaseCell.vue';
import { useElementHover } from '@vueuse/core';
import { ref } from 'vue';

const { task, callback } = defineProps({
    task: {
        type: Object,
        required: true,
    },
    callback: {
        type: Function,
        required: true,
    },
});

const button = ref(null);
const buttonIsHovered = useElementHover(button);
</script>

<template>
    <BaseCell>
        <ToggleTaskOnHoldAction :task="task" :callback="callback">
            <template #button="{ action, loading }">
                <ActionButton
                    ref="button"
                    size="small"
                    square
                    :title="task.onHold ? 'Reprendre' : 'Pause'"
                    :type="task.onHold ? 'danger' : 'success'"
                    :icon="
                        buttonIsHovered
                            ? task.onHold
                                ? PlayIcon
                                : PauseIcon
                            : task.onHold
                              ? PauseIcon
                              : PlayIcon
                    "
                    :callback="() => action()"
                    :loading="loading"
                />
            </template>
        </ToggleTaskOnHoldAction>
    </BaseCell>
</template>
